module.exports = __webpack_public_path__ + "static/img/icon2.b510f1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon2.png
// module id = h2uk
// module chunks = 173